import { Button, Paragraph2, Edit16 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './styles.css';

import niceImg from '../../../../assets/thumbs_up@4x.png';

import { CustomFieldView, ICustomFieldView } from './components/CustomFieldView';
import { CustomFieldLayout } from './components/CustomFieldLayout';

export interface IFormPreview {
  fields: Omit<ICustomFieldView, 'className'>[];
  onEdit(): void;
  isMobile?: boolean;
}

export const FormPreview: React.FC<IFormPreview> = ({ fields, onEdit, isMobile }) => (
  <>
    {!isMobile && (
      <div className={styles['info-block']}>
        <Paragraph2>
          Данные сохранены — отправим их на проверку в Росреестр, как только вы опубликуете объявление
        </Paragraph2>
        <img className={styles['image']} src={niceImg} />
      </div>
    )}
    <div className={styles['fields']}>
      {fields.map(el => (
        <CustomFieldLayout key={el.label} isMobile={isMobile}>
          <CustomFieldView {...el} />
        </CustomFieldLayout>
      ))}
    </div>
    <div className={styles['controls']}>
      <Button
        type="button"
        theme={isMobile ? 'fill_secondary' : 'stroke_secondary'}
        size={isMobile ? 'M' : 'XS'}
        onClick={onEdit}
        fullWidth={isMobile}
        beforeIcon={<Edit16 color={isMobile ? 'primary_100' : 'gray_icons_100'} />}
      >
        Редактировать
      </Button>
    </div>
  </>
);

FormPreview.displayName = 'FormPreview';
